import helper_functions from "../../Config/helper_functions";
import { setTemplateClearPhase2 } from "../../Redux/DownloadSlice/downloadSlice";
import { setTemplateBatch } from "../../Redux/Templates/templateSlice";
import { setTemplate, setTemplate_Edit } from "../../Redux/UserSlice/userSlice";
import {
  setTemplateData,
  setTemplateLoaded,
} from "../../Redux/WaterMarks/wateramarks";
import {
  sendDeleteCallToSever,
  sendGetCallToSever,
  sendPatchCallToSever,
  sendPostCallToSever,
} from "../Axios/Axios";
import UploadMedia from "../UploadMedia/uploadMedia";
import { setLoader } from "../../Redux/MainImage/imageSlice";
import { setWaterMarksLoader } from "../../Redux/WaterMarks/wateramarks";

const SaveTemplate =
  (data, tempLarge, tempThumb, sources, userSliceState) => async (dispatch) => {
    let url =
      userSliceState.edit_Template && !userSliceState.create_Template
        ? `templates/${userSliceState.current_TemplateID}`
        : "templates";
    if (userSliceState.edit_Template && userSliceState.create_Template) {
      // Iterate through each watermark object and remove the 'serverId' property
      data.watermarks?.forEach((watermark) => delete watermark.serverId);
    }
    // SEND CALL TO SERVER TO LOGIN FROM PUNCH
    const resp = await sendPostCallToSever(
      data,
      url,
      userSliceState.edit_Template && !userSliceState.create_Template
    );
    try {
      var result = resp.data.urls;
      var promises = [];
      dispatch(setTemplateClearPhase2(false));
      result?.map(async (item) => {
        if (item.local_id === "template") {
          let buffer1 = helper_functions.dataURLtoFile(
            tempLarge,
            "template_main"
          );
          promises.push(UploadMedia(item.main_pre_signed_url, buffer1));
          let buffer2 = helper_functions.dataURLtoFile(
            tempThumb,
            "template_main"
          );
          promises.push(UploadMedia(item.thumb_pre_signed_url, buffer2));
        } else if (item.local_id) {
          var srcItem = sources.filter((seq) => item.local_id === seq.local_id);
          var fileSrc = srcItem[0].src;
          let dataFile;
          if (typeof fileSrc === "string") {
            dataFile = helper_functions.dataURLtoFile(
              fileSrc,
              "main_pre_signed_url"
            );
            promises.push(UploadMedia(item.main_pre_signed_url, dataFile));
          } else {
            dataFile = helper_functions.blobToFile(
              fileSrc,
              "main_pre_signed_url"
            );
            promises.push(UploadMedia(item.main_pre_signed_url, dataFile));
          }
        }
      });
      await Promise.all(promises);
      return dispatch(VerifyTemplate(resp.data.id));
    } catch (error) {
      console.log("Save template error: ", error);
    }
  };

const VerifyTemplate = (id) => (dispatch) => {
  return sendPatchCallToSever(
    { status: "Completed" },
    `templates/status/${id}`
  ).then((response) => {
    if (response.data) {
      dispatch(GetAllTemplates());

      return true;
    } else return false;
  });
};
const GetAllTemplates = () => (dispatch) => {
  return sendGetCallToSever(`templates`)
    .then((response) => {
      if (response.hasOwnProperty("data")) dispatch(setTemplate(response.data));
      dispatch(setLoader(false));
    })
    .catch((error) => {
      console.log("Get all templates Error", error);
    });
};
const GetTemplateData = (id, prevState, setEdit, setItems) => (dispatch) => {
  return sendGetCallToSever(`templates/${id}`).then(async (response) => {
    dispatch(setWaterMarksLoader(true));

    if (response.hasOwnProperty("data")) {
      // dispatch(setTemplate(response.data))

      let items = response.data.watermarks;
      const reversedArray = [...prevState];

      for (let i = items.length - 1; i >= 0; i--) {
        let data = items[i].data;
        data = JSON.parse(data);
        if (data.type !== "text") {
          await helper_functions
            .WebToFile(items[i].media.url)
            .then(async (file) => {
              data = {
                ...data,
                id: items[i].serverId,
                serverId: items[i].serverId,
                src: file,
              };
            })
            .catch((error) => console.error(error));
        }
        data = {
          ...data,
          id: items[i].serverId,
          serverId: items[i].serverId,
        };

        data = await helper_functions.dataWrapperDecrypt(
          data,
          response.data.platform
        );

        reversedArray.push(data);
      }
      if (setItems) {
        dispatch(setTemplateData(reversedArray));
        dispatch(setTemplateLoaded(true));
      } else {
        dispatch(
          setTemplateBatch({
            id: id,
            watermarks: reversedArray,
          })
        );
      }
      if (setEdit) {
        dispatch(setTemplate_Edit(true));
      }
      dispatch(setLoader(false));
      dispatch(setWaterMarksLoader(false));
      return {
        id: id,
        watermarks: reversedArray,
      };
    } else {
      dispatch(setWaterMarksLoader(false));
    }
  });
};

const GetTemplateDataFromRedux =
  (id, templates, waterMarksState, edit) => async (dispatch) => {
    if (edit) dispatch(setTemplate_Edit(true));
    var template = await templates.templates.filter((item) => item.id === id);

    template = template[0].watermarks;
    dispatch(setTemplateData([]));
    dispatch(setTemplateData(template));
    dispatch(setTemplateLoaded(true));

    dispatch(setLoader(false));
    // if (create)
    //     dispatch(setCreate(1));
    return true;
  };

const DeleteTemplateByID = (id) => (dispatch) => {
  return sendDeleteCallToSever(`templates/${id}/web`).then(async () => {
    dispatch(GetAllTemplates());
  });
};

export {
  SaveTemplate as CreateTemplate,
  VerifyTemplate,
  GetAllTemplates,
  GetTemplateData,
  GetTemplateDataFromRedux,
  DeleteTemplateByID,
};
